<template>
  <div>
    <div
      v-if="notApproved || failedValidations || failedTests || failedVirusScan"
      class="has-text margin-bottom-1"
    >
      <a
        v-if="notApproved"
        :href="item.chocoPackage.GalleryDetailsUrl"
        target="_blank"
      >
        <span class="tags has-addons is-inline margin-left-10">
          <span class="tag">Status</span>
          <span class="tag is-danger">Not approved</span>
        </span>
      </a>

      <a
        v-if="failedVirusScan"
        :href="`${item.chocoPackage.GalleryDetailsUrl}#virus`"
        target="_blank"
      >
        <span class="tags has-addons is-inline margin-left-10">
          <span class="tag">VirusTotal</span>
          <span class="tag is-danger">Flagged</span>
        </span>
      </a>

      <a
        v-if="failedValidations"
        :href="item.chocoPackage.GalleryDetailsUrl"
        target="_blank"
      >
        <span class="tags has-addons is-inline margin-left-10">
          <span class="tag">Validation</span>
          <span class="tag is-warning">
            {{ item.chocoPackage.PackageValidationResultStatus }}</span
          >
        </span>
      </a>

      <a
        v-if="failedTests"
        :href="
          item.chocoPackage.PackageTestResultUrl != ''
            ? item.chocoPackage.PackageTestResultUrl
            : item.chocoPackage.GalleryDetailsUrl
        "
        target="_blank"
      >
        <span class="tags has-addons is-inline margin-left-10">
          <span class="tag">Tests</span>
          <span class="tag is-warning">
            {{ item.chocoPackage.PackageTestResultStatus }}</span
          >
        </span>
      </a>
    </div>

    <div class="notification is-warning margin-bottom-1" v-if="hasMultiple">
      There's at least one other version of this package already installed.
      Either delete the existing versions, add the -m option to install the package side-by-side, or uninstall
      the existing versions.
    </div>

    <div
      class="notification is-warning margin-bottom-1"
      v-if="higherVersionInstalled && !hasAutoUpgrade && !isAutoUpgrade"
    >
      This package version is lower than at least one already installed package.
      Either add the -m option to install the package side-by-side, or uninstall
      the existing versions. You can still use the uninstall command.
    </div>

    <div
      class="notification is-warning margin-bottom-1"
      v-if="hasAutoUpgrade && !isAutoUpgrade"
    >
      One version of this package has scheduled auto upgrade activated. You have
      to delete that package to continue.
    </div>
  </div>
</template>
<script>
import checks from "@/utils/packageCheck";
import status from "@/utils/groupPackageStatus";
import { hasParam } from "@/utils/mdc";
import { isScheduleValid } from "@/utils/packageDate";

export default {
  props: { item: Object },
  computed: {
    hasParam() {
      return param => {
        return hasParam(this.item.tempCommand.parameters, param);
      };
    },

    higherVersionInstalled() {
      return status.isHigherVersionInstalled(this.item);
    },
    hasMultiple() {
      return status.hasMultipleVersions(this.item);
    },
    isUpgradable() {
      return status.isUpgradable(this.item);
    },
    isInstallable() {
      return status.isInstallable(this.item);
    },
    isUninstallable() {
      return status.isUninstallable(this.item);
    },
    hasValidSchedule() {
      return isScheduleValid(this.item.tempSchedule);
    },
    isTempAutoUpgrade() {
      return status.isTempAutoUpgrade(this.item);
    },
    isAutoUpgrade() {
      return status.isAutoUpgrade(this.item);
    },
    hasAutoUpgrade() {
      return status.hasAutoUpgrade(this.item);
    },
    notApproved() {
      return checks.isNotApproved(this.item);
    },
    failedValidations() {
      return checks.hasFailedValidations(this.item);
    },
    failedVirusScan() {
      return checks.hasFailedVirusScan(this.item);
    },
    failedTests() {
      return checks.hasFailedTests(this.item);
    }
  }
};
</script>
